document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector("#product-box");
  const productInfo = document.querySelector(".product-info-wrapper");
  const footer = document.querySelector("#shopify-section-footer");
  
  if (!target || !productInfo || !footer) return;

  let isVisible = false;
  let placeholder = null;

  function createPlaceholder() {
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'product-info-wrapper-placeholder';
      productInfo.parentNode.insertBefore(placeholder, productInfo.nextSibling);
    }
  }

  function setPlaceholderHeight() {
    if (placeholder && productInfo) {
      const rect = productInfo.getBoundingClientRect();
      placeholder.style.height = rect.height + 'px';
    }
  }

  function isFixedAtcOverlappingFooter() {
    const footerRect = footer.getBoundingClientRect();
    const fixedAtcHeight = 130;
    const viewportHeight = window.innerHeight;
    
    return footerRect.top < (viewportHeight - fixedAtcHeight + 20);
  }

  function updateFixedAtcVisibility() {
    const targetRect = target.getBoundingClientRect();
    const shouldShowBasedOnTarget = targetRect.bottom < 0;
    const isOverlappingFooter = isFixedAtcOverlappingFooter();
    
    const shouldShow = shouldShowBasedOnTarget && !isOverlappingFooter;
    
    if (shouldShow && !isVisible) {
      createPlaceholder();
      setPlaceholderHeight();
      placeholder.classList.add('active');
      document.body.classList.add("body-fixed-atc-form");
      productInfo.classList.add("fixed-atc-form");
      isVisible = true;
    } else if ((!shouldShow || isOverlappingFooter) && isVisible) {
      if (placeholder) {
        placeholder.classList.remove('active');
        setTimeout(() => {
          if (placeholder && !isVisible) {
            placeholder.style.height = '0px';
          }
        }, 50);
      }
      productInfo.classList.remove("fixed-atc-form");
      document.body.classList.remove("body-fixed-atc-form");
      isVisible = false;
    }
  }

  const targetObserver = new IntersectionObserver(
    function (entries) {
      updateFixedAtcVisibility();
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -10px 0px"
    }
  );

  const footerObserver = new IntersectionObserver(
    function (entries) {
      updateFixedAtcVisibility();
    },
    {
      threshold: 0,
      rootMargin: "130px 0px 0px 0px"
    }
  );

  let scrollTimeout;
  window.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(updateFixedAtcVisibility, 10);
  }, { passive: true });

  targetObserver.observe(target);
  footerObserver.observe(footer);
  
  updateFixedAtcVisibility();
});
